import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { IoPersonCircle } from 'react-icons/io5';
import axios from 'axios';
import { IsAuth } from '../../../utils/Auth';

const BettingCard = (props) => {
  const [style1, setStyle1] = useState({});
  const [style2, setStyle2] = useState({});
  const [timerDays, setTimerDays] = useState('00');
  const [timerHours, setTimerHours] = useState('00');
  const [timerMinutes, setTimerMinutes] = useState('00');
  const [timerSeconds, setTimerSeconds] = useState('00');
  const user = IsAuth()._id;
  console.log(user);
  const { _id, game, team1, team2, poolAmount, markUp, filledPool } =
    props.item;
  console.log(game);
  // console.log(eventTime);

  let event = _id;

  const t1 = team1.map((team) => team);
  console.log(t1);
  const player1 = t1[0].player1.toString();
  const team1Id = t1[0]._id.toString();

  console.log(player1);
  console.log(team1Id);

  const t2 = team2.map((team) => team);
  const player2 = t2[0].player2.toString();
  const team2Id = t2[0]._id.toString();
  console.log(player2);
  console.log(team2Id);

  // let Pool;
  const Pool = filledPool.map((pool) => pool);
  console.log(Pool);
  const pool1 = Pool[0];
  const pool2 = Pool[1];
  let pool1Amount;
  let pool2Amount;

  // let pool1Amount = 0;
  // let pool2Amount = 0;
  if (pool1 === undefined) {
    const pool1Id = team1Id;

    const pool2Id = team2Id;

    pool1Amount = 0;
    pool2Amount = 0;

    console.log({ pool1Id, pool1Amount, pool2Id, pool2Amount });
  } else if (pool1 !== undefined && pool2 === undefined) {
    // console.log(pool1);
    const pool1Id = pool1._id;
    if (team1Id === pool1Id) {
      pool1Amount = pool1.filledPool;
      pool2Amount = 0;
      console.log({ pool1Amount, pool2Amount });
    } else {
      //  if(team2Id === pool1Id)
      pool2Amount = pool1.filledPool;
      pool1Amount = 0;
      console.log({ pool1Amount, pool2Amount });
    }
  } else {
    const pool1Id = pool1._id;
    //  const pool2Id = pool2._id;
    if (team1Id === pool1Id) {
      pool1Amount = pool1.filledPool;
      pool2Amount = pool2.filledPool;
      console.log({ pool1Amount, pool2Amount });
    } else if (team2Id === pool1Id) {
      pool2Amount = pool1.filledPool;
      pool1Amount = pool2.filledPool;
      console.log({ pool1Amount, pool2Amount });
    }
  }

  const maxAmount = (poolAmount * 0.05).toString();
  console.log(maxAmount);

  const firstProgress = (pool1Amount / poolAmount) * 100;
  const secondProgress = (pool2Amount / poolAmount) * 100;

  console.log(firstProgress);
  console.log(secondProgress);

  //Timer
  let interval = useRef();

  const startTimer = () => {
    const countDownDate = new Date('Jan 25, 2022 00:00:00').getTime();
    console.log(countDownDate);

    interval = setInterval(() => {
      const now = new Date().getTime();
      console.log(now);
      const distance = countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(interval.current);
    };
  }, []);

  const [amount1, setAmount1] = useState('');
  const [amount2, setAmount2] = useState('');

  const Amount1Handler = (e) => {
    setAmount1(e.target.value);
  };
  const Amount2Handler = (e) => {
    setAmount2(e.target.value);
  };

  const Buy1 = async (e) => {
    const amount = amount1;
    const team = team1Id;
    const player = player1;

    var data1 = [event, amount, team, player, user];
    console.log(data1);

    setAmount1('');
  };
  // const data1 = data1;
  // const Buy2 = async (e) => {
  //   const amount = amount2;
  //   const team = team2Id;
  //   const player = player1;

  //   var data2 = [event, amount, team, player, user];
  //   console.log(data2);

  //   setAmount2('');
  // };
  // const data2 = data2;
  const Buy2 = async (e) => {
    const amount = amount2;
    const team = team2Id;
    const player = player1;

    const response = await axios
      .post(`/api/v1/stakes/buystake`, {
        event,
        amount,
        team,
        player,
        user,
      })
      .then((response) => {
        console.log(response.data);
        console.log('Bought Successfully');
      })
      .catch((err) => console.log(err.response.data.error));

    setAmount2('');
  };

  return (
    <div className=''>
      <div className='pt-5 px-5'>
        <div className='border-1 p-3 cardRadius'>
          <div className='d-md-flex justify-content-between p-md-3'>
            <div>
              <h4 className='gameText'>{game}</h4>
              <h4 className='captionText'>Caption</h4>
              <Link to={`/gamedescription/${_id}`}>
                <h5
                  style={{ cursor: 'pointer' }}
                  className='pt-2 text-decoration-underline textSky fw-bold'
                >
                  Read More....
                </h5>
              </Link>
            </div>
            <div>
              <div className='card px-5 py-2 border border-dark'>
                <div className='d-md-flex gap-2 align-items-center'>
                  <h4 className='pt-1 timeleftText'>
                    {timerDays} &nbsp; {timerHours} {timerMinutes}{' '}
                    {timerSeconds}
                  </h4>{' '}
                  Left
                </div>
              </div>
            </div>
          </div>
          <div className='d-xl-flex justify-content-between p-md-4'>
            <div
              style={{ backgroundColor: '#f4f4f4' }}
              className='card border-1 rounded mt-2'
            >
              <div className='d-md-flex p-4 mt-md-3'>
                <IoPersonCircle color='#432344' size={43} />

                <h4 className='p-2 playernameText pe-3'>{player1}</h4>

                <input
                  className='enteramtTextField mt-1 ps-3'
                  placeholder='Enter Amount'
                  type='number'
                  name='amount1'
                  value={amount1}
                  onChange={Amount1Handler}
                  min='10'
                  max={maxAmount}
                ></input>

                <Link to={`/paymentpage/${Buy1}`}>
                  <button
                    className='buyBtn mt-1'
                    // type='submit'
                    onClick={Buy1}
                  >
                    Buy
                  </button>
                </Link>
                {/* <Link to='/paymentpage'>
                  <button className='buyBtn mt-1'>Buy</button>
                </Link> */}
              </div>
              <div style={{ height: '0.5rem' }} className='card mt-3'>
                <div
                  style={{
                    width: `${firstProgress}%`,
                    maxWidth: '100%',
                    backgroundColor: '#ffba00',
                    height: '0.5rem',
                  }}
                  className='card'
                ></div>
              </div>
            </div>

            <div className='mt-3'>
              <p className=' poolamtText p-2'>
                Pool Amount &nbsp; {poolAmount}
              </p>
              <p className='markupText p-2'>
                Mark Up &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; {markUp}
              </p>
            </div>

            <div
              style={{ backgroundColor: '#f4f4f4' }}
              className='card border-1 rounded mt-2'
            >
              <div className='d-sm-flex p-4 mt-3'>
                <IoPersonCircle color='#432344' size={43} />

                <h4 className='p-2 playernameText pe-3'>{player2}</h4>

                <input
                  className='enteramtTextField mt-1 ps-3'
                  placeholder='Enter Amount'
                  type='number'
                  name='amount2'
                  value={amount2}
                  min='10'
                  max={maxAmount}
                  onChange={Amount2Handler}
                ></input>

                {/* <Link to={`/paymentpage/${Buy2}`}> */}
                <button className='buyBtn mt-1' onClick={Buy2}>
                  Buy
                </button>
                {/* </Link> */}
                {/* <Link to='/paymentpage'>
                  <button className='buyBtn mt-1'>Buy</button>
                </Link> */}
              </div>
              <div style={{ height: '0.5rem' }} className='card mt-3'>
                <div
                  style={{
                    width: `${secondProgress}%`,
                    maxWidth: '100%',
                    backgroundColor: '#ffba00',
                    height: '0.5rem',
                  }}
                  className='card'
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BettingCard;
